import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import CartItem from './CartItem';
import StepIndicator from '../layout/StepIndicator';

// Pantalla de carrito dedicada (reemplaza el panel flotante).
const CartScreen = () => {
    const { items, total, clearCart } = useCart();
    const navigate = useNavigate();

    const itemCount = items.reduce((n, it) => n + (it.quantity || 0), 0);
    const iva = Math.round(total * 0.19);
    const neto = Math.round(total) - iva;
    const empty = items.length === 0;

    const money = (n) => `$${Math.round(n).toLocaleString('es-CL')}`;

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: 'transparent' }}>
            <StepIndicator />
            {/* Header */}
            <div style={{ background: '#009542', color: '#fff', padding: '1.8rem 2rem', display: 'flex', alignItems: 'center', gap: 18, boxShadow: '0 4px 14px rgba(0,0,0,0.2)' }}>
                <button onClick={() => navigate('/products')}
                    style={{ background: 'rgba(255,255,255,0.18)', color: '#fff', border: '1px solid rgba(255,255,255,0.35)', borderRadius: 16, width: 60, height: 60, fontSize: '2rem', fontWeight: 900, cursor: 'pointer', lineHeight: 1 }}>
                    ‹
                </button>
                <div style={{ flex: 1 }}>
                    <h1 style={{ fontSize: '2.4rem', fontWeight: 900, margin: 0 }}>Tu Pedido</h1>
                    <p style={{ margin: '4px 0 0', color: '#c9c0b3', fontWeight: 700 }}>
                        {itemCount} {itemCount === 1 ? 'producto' : 'productos'}
                    </p>
                </div>
                {!empty && (
                    <button onClick={clearCart}
                        style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.55)', borderRadius: 14, padding: '12px 20px', fontWeight: 700, cursor: 'pointer' }}>
                        Vaciar
                    </button>
                )}
            </div>

            {/* Contenido */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }} className="hide-scrollbar">
                {empty ? (
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: '#8a8175' }}>
                        <svg width="86" height="86" viewBox="0 0 24 24" fill="none" stroke="#c9c0b3" strokeWidth="1.4" style={{ marginBottom: 12 }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <h2 style={{ fontSize: '2rem', fontWeight: 800, color: '#5a5142', margin: 0 }}>Tu carrito está vacío</h2>
                        <p style={{ fontSize: '1.2rem', marginTop: 8 }}>Añade productos para empezar tu pedido</p>
                        <button onClick={() => navigate('/products')}
                            style={{ marginTop: 24, background: '#009542', color: '#fff', border: 'none', borderRadius: 16, padding: '16px 34px', fontWeight: 800, fontSize: '1.1rem', cursor: 'pointer' }}>
                            Volver al menú
                        </button>
                    </div>
                ) : (
                    <div style={{ maxWidth: 900, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 14 }}>
                        {items.map(item => (
                            <div key={item.id} style={{ background: '#fff', borderRadius: 18, boxShadow: '0 4px 14px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                                <CartItem item={item} isPaymentScreen={false} />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Footer resumen + continuar */}
            {!empty && (
                <div style={{ background: '#fff', borderTop: '1px solid #e7e0d3', padding: '18px 24px', boxShadow: '0 -6px 20px rgba(0,0,0,0.06)' }}>
                    <div style={{ maxWidth: 900, margin: '0 auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#64748b', fontWeight: 600, marginBottom: 4 }}>
                            <span>Subtotal (Neto)</span><span>{money(neto)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#64748b', fontWeight: 600, marginBottom: 10 }}>
                            <span>IVA (19%)</span><span>{money(iva)}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px dashed #e2e8f0', paddingTop: 12, marginBottom: 16 }}>
                            <span style={{ fontSize: '1.6rem', fontWeight: 900, color: '#009542' }}>Total</span>
                            <span style={{ fontSize: '2rem', fontWeight: 900, color: '#009542' }}>{money(total)}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 14 }}>
                            <button onClick={() => navigate('/products')}
                                style={{ flex: '0 0 auto', background: '#f1efe9', color: '#5a5142', border: '1px solid #e0d8c9', borderRadius: 16, padding: '18px 28px', fontWeight: 800, fontSize: '1.05rem', cursor: 'pointer' }}>
                                Seguir agregando
                            </button>
                            <button onClick={() => navigate('/order-type')}
                                style={{ flex: 1, background: '#009542', color: '#fff', border: 'none', borderRadius: 16, padding: '18px 28px', fontWeight: 900, fontSize: '1.2rem', cursor: 'pointer', boxShadow: '0 6px 18px rgba(0,149,66,0.35)' }}>
                                CONTINUAR ›
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>
        </div>
    );
};

export default CartScreen;
